var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSedanDefault = function SvgSedanDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeWidth: 0.8,
    d: "M13.405 14.17a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0ZM37.346 14.17a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeWidth: 0.774,
    d: "M30.39 6.96c-2.565-1.577-6.872-2.143-9.233-2.294-.537-.035-.914.492-.734.999l.667 1.88a.76.76 0 0 0 .699.51c2.01.045 5.896.008 8.206-.01.664-.004.96-.738.394-1.085ZM19.133 5.484l.542 1.507a.777.777 0 0 1-.736 1.039 585 585 0 0 0-5.602.005c-.595.002-.893-.599-.424-.964 1.31-1.02 3.545-1.899 5.477-2.078.33-.031.63.178.742.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m9.985 15-3.974-1.565a.3.3 0 0 1-.074-.045v0a2.47 2.47 0 0 1-.447-3.176l.09-.14a.3.3 0 0 0 .039-.11l.283-2.324a.79.79 0 0 1 .614-.673c1.613-.367 4.983-1.27 9.051-2.761 1.722-.574 8.794-2.675 18.895 3.39.07.042.149.074.229.093 2.401.548 4.23.813 7.745 2.232a.6.6 0 0 1 .248.177c.338.431 1.254 1.902.228 3.775a.71.71 0 0 1-.476.345L38.914 15m-23.929 0h18.929"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.521,
    cy: 14.172,
    r: 2.331,
    stroke: "#374255",
    strokeWidth: 0.774
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeWidth: 0.774,
    d: "M38.789 14.172a2.33 2.33 0 1 1-4.662 0 2.33 2.33 0 0 1 4.662 0Z"
  })));
};
export default SvgSedanDefault;